/* this file added by Bearer Web Developer  */
import { observer } from "mobx-react-lite";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useAppState } from "../../states/app-state";
import ApiIntegration from "../apiIntegration";
import styles from './apiIntegrationPopup.module.scss';
import { useThemeMode } from "../../states/contexts/theme";

const ApiIntegrationPopup: React.FC = observer(() => {
   const appState = useAppState();
   const { apiIntegrationOpen: open, setApiIntegrationOpen } = appState?.ApiIntegration;
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 900px max width
   const handleClose = () => { setApiIntegrationOpen(false); };
   const { theme: themeMode } = useThemeMode();
   return (
      <>
         {
            isMobile ?
               <Dialog open={open} onClose={handleClose}
                  slotProps={{
                     paper: {
                        sx: {
                           borderRadius: "10px", margin: "10px", minHeight: "calc(100% - 20px)", maxWidth: "100%", // minHeight is 100% - margin top and bottom
                           backgroundColor: themeMode === "dark" ? 'var(--neutral-hsb-15, #262626)' : '#fff'
                        },
                        classes: { root: styles.paper_dialog, }
                     },
                  }}
               >
                  <ApiIntegration />
               </Dialog>
               :
               <div className={styles.decktop} data-theme={themeMode}> {/* data-theme property added by Bearer Web Developer */}
                  <ApiIntegration />
               </div>
         }
      </>
   )
});
export default ApiIntegrationPopup;

